export default __webpack_public_path__ + "static/media/mapBlueVehicle.7b8606e9.png";